import React, { FC } from 'react';
import { IoLocationSharp, IoMail, IoCallSharp, IoLogoWhatsapp } from 'react-icons/io5';
import Link from '@components/ui-old/link';
import { useTranslation } from 'next-i18next';
import { getCurrentLocationAndLanguage, Location } from '../utils/location';
interface Props {
  selectedLocationIndex: number;
  setSelectedLocationIndex: (index: number) => void;
}
interface ContactItem {
  id: number;
  slug: string;
  icon: JSX.Element;
  name: string;
  description: string;
}
interface LocationInfo {
  name: string;
  contact: ContactItem[];
}
type ContactData = { [key in Location]: LocationInfo[] };
export const contactData: ContactData = {
  tr: [{
    name: 'İstanbul',
    contact: [{
      id: 1,
      icon: <IoLocationSharp />,
      name: 'text-address',
      description: 'Gazeteciler Sitesi Yazarlar Sokak No:8 Esentepe Mahallesi Şişli/İstanbul',
      slug: 'https://maps.app.goo.gl/NZ58L8mdbu2VX9Wv6'
    }, {
      id: 2,
      icon: <IoMail />,
      name: 'text-email',
      description: 'info@flptr.com',
      slug: 'mailto:info@flptr.com'
    }, {
      id: 3,
      icon: <IoCallSharp />,
      name: 'text-phone',
      description: '+90 (212) 347 71 26',
      slug: 'tel:+902123477126'
    }, {
      id: 4,
      icon: <IoLogoWhatsapp />,
      name: 'Whatsapp',
      description: '+90 539 661 72 77',
      slug: 'https://wa.me/+905396617277'
    }]
  }, {
    name: 'İzmir',
    contact: [{
      id: 5,
      icon: <IoLocationSharp />,
      name: 'text-address',
      description: 'İsmet Kaptan Mahallesi 1371 Sokak No.3/A, Çankaya - Konak / İzmir',
      slug: 'https://maps.app.goo.gl/YDEPrrcpaRMQEoiB8'
    }, {
      id: 6,
      icon: <IoMail />,
      name: 'text-email',
      description: 'info@flptr.com',
      slug: 'mailto:support@flptr.com'
    }, {
      id: 7,
      icon: <IoCallSharp />,
      name: 'text-phone',
      description: '+90 (232) 445 63 44',
      slug: 'tel:+902324456344'
    }, {
      id: 8,
      icon: <IoLogoWhatsapp />,
      name: 'Whatsapp',
      description: '+90 539 661 72 77',
      slug: 'https://wa.me/+905396617277'
    }]
  }],
  uz: [{
    name: 'Uzbekistan',
    contact: [{
      id: 1,
      icon: <IoLocationSharp />,
      name: 'text-address',
      description: 'footer:text-tashkent-address',
      slug: 'https://maps.app.goo.gl/CUnjpWygBQv373AS7'
    }, {
      id: 2,
      icon: <IoMail />,
      name: 'text-email',
      description: 'flpuzbekistan@gmail.com',
      slug: 'mailto:flpuzbekistan@gmail.com'
    }, {
      id: 3,
      icon: <IoCallSharp />,
      name: 'text-phone',
      description: '+998 91 774 79 77',
      slug: 'tel:+998917747977'
    }]
  }],
  kg: [{
    name: 'Bishkek',
    contact: [{
      id: 1,
      icon: <IoLocationSharp />,
      name: 'text-address',
      description: 'footer:text-bishkek-address',
      slug: 'https://goo.gl/maps/bpwfdSksBDuD7CHk7'
    }, {
      id: 2,
      icon: <IoMail />,
      name: 'text-email',
      description: 'flpkyrgyzstan@yahoo.com',
      slug: 'mailto:flpkyrgyzstan@yahoo.com'
    }, {
      id: 3,
      icon: <IoCallSharp />,
      name: 'text-phone',
      description: '0 (312) 62 49 06',
      slug: 'tel:+996312624906'
    }, {
      id: 4,
      icon: <IoLogoWhatsapp />,
      name: 'Whatsapp',
      description: '0 (555) 62 49 06',
      slug: 'https://wa.me/+996555624906'
    }]
  }
  // {
  //   name: 'Osh',
  //   contact: [
  //     {
  //       id: 5,
  //       icon: <IoLocationSharp />,
  //       name: 'text-address',
  //       description: 'Osh prospect Masaliev 39',
  //       slug: 'https://maps.app.goo.gl/JKswAH3rmhcJui7i7',
  //     },
  //     {
  //       id: 6,
  //       icon: <IoMail />,
  //       name: 'text-email',
  //       description: 'flpkyrgyzstan@yahoo.com',
  //       slug: 'mailto:flpkyrgyzstan@yahoo.com',
  //     },
  //     {
  //       id: 7,
  //       icon: <IoCallSharp />,
  //       name: 'text-phone',
  //       description: '0 (312) 62 49 06',
  //       slug: 'tel:+996312624906',
  //     },
  //     {
  //       id: 8,
  //       icon: <IoLogoWhatsapp />,
  //       name: 'Whatsapp',
  //       description: '0 (555) 62 49 06',
  //       slug: 'https://wa.me/+996555624906',
  //     },
  //   ],
  // },
  ],
  kz: [{
    name: 'Almaty',
    contact: [{
      id: 1,
      icon: <IoLocationSharp />,
      name: 'text-address',
      description: 'Almaty m-district Zhetysu - 2 House 15 А',
      slug: 'https://goo.gl/maps/Uixjb6cRvUT2hbiY9'
    }, {
      id: 2,
      icon: <IoMail />,
      name: 'text-email',
      description: 'flpkazakhstan@gmail.com',
      slug: 'mailto:flpkazakhstan@gmail.com'
    }, {
      id: 3,
      icon: <IoCallSharp />,
      name: 'text-phone',
      description: '+7 (727) 374 97 37',
      slug: 'tel:+77273749737'
    }]
  }, {
    name: 'Astana',
    contact: [{
      id: 4,
      icon: <IoLocationSharp />,
      name: 'text-address',
      description: 'Astana Sh. Ualihanov str. House 12',
      slug: 'https://go.2gis.com/O0Fst'
    }, {
      id: 5,
      icon: <IoMail />,
      name: 'text-email',
      description: 'flpastana@flpkz.kz',
      slug: 'mailto:flpastana@flpkz.kz'
    }, {
      id: 6,
      icon: <IoCallSharp />,
      name: 'text-phone',
      description: '+7 (7172) 79 50 35',
      slug: 'tel:+77172795035'
    }]
  }, {
    name: 'Atyrau',
    contact: [{
      id: 7,
      icon: <IoLocationSharp />,
      name: 'text-address',
      description: 'Atyrau, Avangard 2-nd m-district, House 11-B, Block 4, ground floor, place #3 ("Modern Stroi")',
      slug: 'https://maps.app.goo.gl/De8H5iGYieeVcftP7'
    }, {
      id: 8,
      icon: <IoMail />,
      name: 'text-email',
      description: 'flpatyrau@flpkz.kz',
      slug: 'mailto:flpatyrau@flpkz.kz'
    }, {
      id: 9,
      icon: <IoCallSharp />,
      name: 'text-phone',
      description: '+7 (7122) 507-000',
      slug: 'tel:+77122507000'
    }]
  }],
  az: [{
    name: 'Azerbaycan',
    contact: [{
      id: 1,
      icon: <IoLocationSharp />,
      name: 'text-address',
      description: 'footer:text-baku-address',
      slug: 'https://goo.gl/maps/59Y9BsudgUpUL6g47'
    }, {
      id: 2,
      icon: <IoMail />,
      name: 'text-email',
      description: 'flpazerbaijan@yahoo.com',
      slug: 'mailto:flpazerbaijan@yahoo.com'
    }, {
      id: 3,
      icon: <IoCallSharp />,
      name: 'text-phone',
      description: '+994 12 465 43 96',
      slug: 'tel:+994124654396'
    }]
  }],
  iq: [{
    name: 'Iraq',
    contact: [{
      id: 1,
      icon: <IoLocationSharp />,
      name: 'text-address',
      description: 'Zaniari District No:30/89 Behind the First Erbil Tower (Francois Hariri Stadium) Erbil, Iraq',
      slug: 'https://maps.app.goo.gl/AjNK34PsFNgJMZTf8'
    }, {
      id: 2,
      icon: <IoMail />,
      name: 'text-email',
      description: 'flpiraq@ymail.com',
      slug: 'mailto:flpiraq@ymail.com'
    }, {
      id: 3,
      icon: <IoCallSharp />,
      name: 'text-phone',
      description: '+964 7508208001',
      slug: 'tel:+9647508208001'
    }]
  }],
  ge: [{
    name: 'Georgia',
    contact: [{
      id: 1,
      icon: <IoLocationSharp />,
      name: 'text-address',
      description: 'footer:text-tblisi-address',
      slug: 'https://maps.app.goo.gl/FNXvvg2DvyDBgscS6'
    }, {
      id: 2,
      icon: <IoMail />,
      name: 'text-email',
      description: 'flpgeorgia@yahoo.com',
      slug: 'mailto:flpgeorgia@yahoo.com'
    }, {
      id: 3,
      icon: <IoCallSharp />,
      name: 'text-phone',
      description: '+995 59 905 99 39',
      slug: 'tel:+995599059939'
    }, {
      id: 4,
      icon: <IoLogoWhatsapp />,
      name: 'Whatsapp',
      description: '+995 59 905 99 39',
      slug: 'https://wa.me/+995599059939'
    }]
  }]
};
const ContactInfoBlock: FC<Props> = ({
  selectedLocationIndex,
  setSelectedLocationIndex
}) => {
  const {
    t
  } = useTranslation('common');
  const {
    location
  } = getCurrentLocationAndLanguage();
  const currentLocations: LocationInfo[] = contactData[location] || contactData['tr'];
  const selectedLocation = currentLocations[selectedLocationIndex];
  const renderContactDescription = (item: ContactItem) => {
    if (item.name.toLowerCase().includes('address') || item.name.toLowerCase().includes('whatsapp') || item.name.toLowerCase().includes('email') || item.name.toLowerCase().includes('phone')) {
      return <a href={item.slug} target="_blank" rel="noopener noreferrer" className="text-sm mt-0 hover:underline text-neutral-700 dark:text-neutral-300">
          {t(item.description)}
        </a>;
    }
    return <Link href={item.slug} className="text-sm mt-0 hover:underline text-neutral-700 dark:text-neutral-200" data-sentry-element="Link" data-sentry-component="renderContactDescription" data-sentry-source-file="contact-info.tsx">
        {t(item.description)}
      </Link>;
  };
  return <div className="mb-6 lg:border lg:rounded-md border-neutral-300 dark:border-neutral-800 lg:p-7" data-sentry-component="ContactInfoBlock" data-sentry-source-file="contact-info.tsx">
      <h4 className="text-2xl md:text-2xl font-bold text-heading dark:text-neutral-200 pb-7 md:pb-10 lg:pb-6 -mt-1">
        {t('text-find-us-here')}
      </h4>
      {currentLocations.length > 1 && <div className="mb-6 p-2">
          <div className="flex flex-wrap gap-2">
            {currentLocations.map((loc, index) => <button key={index} onClick={() => setSelectedLocationIndex(index)} className={`px-4 py-2 border rounded-md ${selectedLocationIndex === index ? 'bg-primary text-white dark:text-neutral-800' : 'bg-white dark:bg-zinc-950 text-neutral-700 dark:text-neutral-200 border-neutral-300 dark:border-neutral-600 hover:bg-neutral-100'}`} aria-pressed={selectedLocationIndex === index} aria-label={`Select ${loc.name}`}>
                {loc.name}
              </button>)}
          </div>
        </div>}
      {selectedLocation && <div>
          {selectedLocation.contact.map((item: ContactItem) => <div key={`contact--key${item.id}`} className="flex pb-7">
              <div className="flex flex-shrink-0 justify-center items-center p-1.5 border rounded-md border-neutral-300 dark:border-neutral-800 w-10 h-10">
                {item.icon}
              </div>
              <div className="flex flex-col ltr:pl-3 rtl:pr-3 ltr:2xl:pl-4 rtl:2xl:pr-4">
                <h5 className="text-sm font-bold text-heading dark:text-neutral-200">
                  {t(item.name)}
                </h5>
                {renderContactDescription(item)}
              </div>
            </div>)}
        </div>}
    </div>;
};
export default ContactInfoBlock;